import React from "react"
import {FieldEditableProps} from "../../../../../proto/render/editable";
import {FieldViewSize} from "../../../../../const";

const debug = false
// const debug = "FieldCheckbox_Editable"

export default function FieldCheckbox_Editable(props:FieldEditableProps) {

    debug && console.log(debug, props)
    debug && console.log(debug, props.field.getViewValue(props.model))

    const value = props.field.getViewValue(props.model)

    const onChange = (newValue:any) => {

        if (props.disabled || !props.field.canEdit(props.model)) return false


        props.onChange && props.onChange(newValue)
    }

    const toggleValue = () => {
        onChange(!value)
    }

    const classes = Classes("ui5-field-editable", props.className, {
        "size-small"                    : props.size === FieldViewSize.SMALL,
        "size-default"                  : props.size === FieldViewSize.DEFAULT,
    })




    // const checkboxClasses = Classes("ui5-cb", "s-{0}".f(this.props.field.size), {selected: this.state.value});
    //     //
    //     // return (
    //     //     <div className={Classes("ui5-field-form-editable no-border transparent-bg min-h-36 p-l-10 p-r-10", this.props.className)}>
    //     //         <div className={classes} onClick={this.onClick}/>
    //     //     </div>
    //     // )



    const checkboxClasses = Classes("ui5-cb", "s-{0}".f(props.field.size), {
        selected: value
    });

    return (
        <div className={classes}>
            <div className={checkboxClasses} onClick={toggleValue}/>
            {/*<FieldCheckbox_FormCommon {...props} value={value} onChange={onChange} />*/}
        </div>
    )

}
